var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"war-room-banner"},[_c('div',{staticClass:"war-room-banner__header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"war-room-banner__content"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"war-room-banner__footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }